import { useEffect, useState } from 'react';
import { getFirebaseToken } from '../../infra/auth/firebase-auth';
import { useAtom, useSetAtom } from 'jotai';
import { userTokenAtom } from '../states/user';

// we have to fetch again and again as token get expire
export const useGetToken = () => {
  const [token, setToken] = useAtom(userTokenAtom);

  useEffect(() => {
    try {
      const fetchToken = async () => {
        const token = await getFirebaseToken();
        if (token) {
          setToken(token ? encodeURIComponent(token) : null);
        }
      };
      fetchToken();
    } catch (e) {
      console.log('Exception', e);
    }
  }, [setToken]);

  return token;
};
